import { render, staticRenderFns } from "./PhotoBox.vue?vue&type=template&id=5f53d0a8&scoped=true"
import script from "./PhotoBox.vue?vue&type=script&lang=js"
export * from "./PhotoBox.vue?vue&type=script&lang=js"
import style0 from "./PhotoBox.vue?vue&type=style&index=0&id=5f53d0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f53d0a8",
  null
  
)

export default component.exports